/** Identificador estável do documento jurídico — atualize ao publicar nova versão dos Termos. */
export const TERMS_DOCUMENT_ID = "fabchat-termos-servico-v2026-09-18";

/** Versão semântica exibida ao usuário e registrada no aceite eletrônico. */
export const TERMS_VERSION = "2026.09.18";

/** Data de vigência da versão atual (formato ISO para registro; exibir em pt-BR na página). */
export const TERMS_EFFECTIVE_DATE = "2026-09-18";

export const TERMS_EFFECTIVE_DATE_LABEL = "18 de setembro de 2026";

export const TERMS_WITHDRAWAL_DAYS = 7;
